import Head from 'next/head'
import Layout from '../components/Layout'

import { DiscountTireHeader } from '../components/DiscountTire/DiscountTireHeader'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandHoldingDollar } from '@fortawesome/pro-duotone-svg-icons'
import { faCalendarDay } from '@fortawesome/pro-duotone-svg-icons'
const DiscountTirePage = () => {
  return (
    <Layout
      title="Discount Tire & NuBrakes | NuBrakes Mobile Fleet Services"
      description="Eliminate downtime and maximize revenue generation with NuBrakes Mobile Fleet Services. We come to you and work around your schedule 7 days a week! Book now!"
      showFooter={false}
      showGetQuote={false}
      showNavBar={false}
    >
      <Head>
        <meta name="robots" content="noindex,nofollow" />
      </Head>
      <DiscountTireHeader />
      <section className="bg-gray-200 text-center px-4">
        <div className="pb-10">
          <h2>Why Choose NuBrakes Fleet Maintenance?</h2>
          <p>
            Eliminate downtime and maximize revenue generation with NuBrakes Mobile Fleet Services. We come to you and
            work around your schedule 7 days a week! Book now!
          </p>
        </div>
        <div className="grid lg:grid-cols-4 grid-cols-1 gap-8">
          <div className="lg:col-start-2 flex flex-col space-y-4">
            <FontAwesomeIcon icon={faHandHoldingDollar} style={{ color: 'f04f23' }} size={'5x'} />
            <h3>Eliminate Downtime and Maximize Revenue</h3>
            <p>
              We come to you. Eliminate the extra time and money it takes to send yourself or an employee to the repair
              shop.
            </p>
          </div>
          <div className="flex flex-col space-y-4">
            <FontAwesomeIcon icon={faCalendarDay} style={{ color: 'f04f23' }} size={'5x'} />
            <h3>Repairs Around Your Schedule</h3>
            <p>
              Choose a repair schedule that works around your business operations, or schedule on-demand service as
              needed
            </p>
          </div>
        </div>
      </section>
      <section className="text-center">
        <h2>NuBrakes Services and Pricing</h2>
        <p>We service Class 1-3 vehicles and are available seven days a week!</p>
        <div className="flex flex-row justify-center text-left">
          <ul className="list-disc">
            <li>
              Brake Pad and Rotors Replacement (single Axle) starting at $450
              <ul className="list-disc my-0">
                <li>Pad Replacement</li>
                <li>Rotor Replacement</li>
                <li>Caliper Replacement</li>
                <li>Hose Replacement</li>
                <li>Brake Fluid Exchange</li>
              </ul>
            </li>
            <li>
              Standalone Oil Change;
              <ul className="my-0">
                <li>Multiple Vehicles - $80 per gas vehicle (2 or More)</li>
                <li>Single Vehicle - $90 per gas vehicle (Single Vehicle Visit)</li>
                <li>Diesel Vehicle - $135 per diesel vehicle</li>
              </ul>
            </li>
            <li>Maintenance Packages (Oil Change, Filter replacements, Inspection) starting at $179</li>
            <li>Cabin Filter Replacement (Add on) starting at $59</li>
            <li>Engine Filter Replacement (Add on) starting at $59</li>
            <li>Wiper Blades (Add on) starting at $50</li>
            <li>Standalone Telematics Installation starting at $99</li>
            <li>Standalone Vehicle Inspections starting at $49</li>
          </ul>
        </div>
      </section>
    </Layout>
  )
}
export default DiscountTirePage
